<template>
    <v-dialog
        max-width="600"
        transition="dialog-top-transition"
        v-model="studentDialog"
        overlay-color="accent"
        overlay-opacity="0.6"
        persistent
    >
        <psi-dialog
            v-if="studentDialog"
            title="Get Help"
            :icon="$config('icons.help')"
            @close="close"
        >
            <v-alert border="top" color="accent" outlined prominent>
                <p>
                    Questions about your tenant sample report? Send us a message
                    below and a customer service representative will reach out
                    to you within 24-48 hours.
                </p>
            </v-alert>

            <psi-form-element label="Message" required>
                <v-textarea
                    class="mt-2"
                    v-model="message"
                    name="message"
                    auto-grow
                    solo
                    clearable
                    full-width
                    label="Enter Message"
                    placeholder="Enter message"
                    :rules="[(v) => !!v || 'Message is required']"
                >
                </v-textarea>
            </psi-form-element>
            <template #actions>
                <v-btn class="mr-4" @click.stop="close">Cancel</v-btn>
                <v-btn color="accent" class="px-4" @click.stop="sendMessage">
                    <v-icon class="mr-1">mdi-email-send</v-icon>
                    Send
                </v-btn>
            </template>
        </psi-dialog>
    </v-dialog>
</template>

<script>
export default {
    name: "student-help",
    props: {
        dialog: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            studentDialog: false,
            message: "",
        };
    },
    watch: {
        dialog: {
            immediate: true,
            handler(dialog) {
                this.studentDialog = dialog;
            },
        },
    },
    methods: {
        close() {
            this.studentDialog = false;
            this.$emit("update:dialog", false);
        },
        sendMessage() {
            this.$emit("send-message", this.message);
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>